export const SortingOptions = {
    Availability: 'AVAILABILITY',
    Default: 'DEFAULT',
    Distance: 'DISTANCE',
    WaitTime: 'WAIT_TIME',
};
